import { z } from 'zod';
import { apiUrl } from '../config/api';
import type { Location } from '../data/databaseSchema';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema, locationSchema } from '../lib/schemas';

export const locationService = {
  async getLocations(): Promise<Location[]> {
    const result = await apiClient.get(apiUrl.locations(), {
      validate: envelopeSchema('locations', z.array(locationSchema)),
      deduplicate: true,
      context: 'getLocations',
    });
    return result.locations;
  },

  async createLocation(location: Partial<Location>): Promise<Location> {
    const result = await apiClient.post(apiUrl.locations(), location, {
      validate: envelopeSchema('location', locationSchema),
      context: 'createLocation',
    });
    return result.location;
  },

  async updateLocation(id: string, location: Partial<Location>): Promise<Location> {
    const result = await apiClient.put(`${apiUrl.locations()}/${id}`, location, {
      validate: envelopeSchema('location', locationSchema),
      context: 'updateLocation',
    });
    return result.location;
  },

  async deleteLocation(id: string): Promise<void> {
    await apiClient.delete(`${apiUrl.locations()}/${id}`, {
      context: 'deleteLocation',
    });
  },
};
